var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Select',_vm._b({staticStyle:{"width":"200px"},attrs:{"value":_vm.value,"clearable":""},on:{"input":_vm.inputHandler}},'Select',_vm.selectProps,false),_vm._l((_vm.options),function(api){return _c('Option',{key:api.value,attrs:{"value":api.value}},[_vm._v(" "+_vm._s(api.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }